import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Typography,
  AppBar
} from '@mui/material';
import {
  Assessment,
  AccountBalance,
  Assignment,
  Analytics
} from '@mui/icons-material';
import FinancialReports from './FinancialReports';
import ProjectReports from './ProjectReports';
import StudioAnalytics from './StudioAnalytics';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function Reports() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Reports & Analytics
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Comprehensive business insights and performance metrics
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <AppBar position="static" color="default" elevation={0}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab 
              label="Financial Report" 
              icon={<AccountBalance />} 
              iconPosition="start"
            />
            <Tab 
              label="Project Report" 
              icon={<Assignment />} 
              iconPosition="start"
            />
            <Tab 
              label="Studio Analytics" 
              icon={<Analytics />} 
              iconPosition="start"
            />
          </Tabs>
        </AppBar>

        <TabPanel value={tabValue} index={0}>
          <FinancialReports />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <ProjectReports />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <StudioAnalytics />
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default Reports;
